import * as moment from "moment";
import { Tag } from "./Tag";

export class PacchettoItem {

    associata_item: any;
    associate: boolean;
    associate_sconto: any;
    cancellato: number;
    cantina: any;
    cantinalink: any;
    codiceForm: string;
    costo: number;
    costo_scontato: number;
    descrizione: string;
    id: number;
    idCantina: number;
    imgsrc: string;
    inclusi: any;
    isBestsellers: boolean;
    inSconto: boolean;
    finePromo: string;
    nome: string;
    opzioni: Array<any>;
    ordine: number;
    pubblica: boolean;
    titolo: string;
    vini: Array<any>;
    qta: number;
    visite: Array<any>;
    buono: number;
    tags: Array<Tag> = [];
    recensioni: any;
    totVenduti: number;
    evidenza: boolean;
    idregione: number;
    giorniOffset: string;
    winecoins: number;
    denominazione: string;
    slider: Array<any>;
    modrewrite: string;
    regione: string;
    provincia: string;


    constructor(pacchetto) {
        this.associata_item = pacchetto.associata_item;
        this.associate = pacchetto.associate;
        this.associate_sconto = pacchetto.associate_sconto;
        this.cancellato = parseInt(pacchetto.cancellato, 10);
        this.cantina = pacchetto.cantina;
        this.cantinalink = pacchetto.cantinalink;
        this.codiceForm = pacchetto.codiceForm;
        this.costo = parseFloat(pacchetto.costo);
        this.costo_scontato = pacchetto.costo_scontato ? parseFloat(pacchetto.costo_scontato) : this.costo;
        this.descrizione = pacchetto.descrizione;
        this.finePromo = pacchetto.finePromo;
        this.id = parseInt(pacchetto.id, 10);
        this.idCantina = parseInt(pacchetto.idCantina, 10);
        this.imgsrc = pacchetto.imgsrc;
        this.inclusi = pacchetto.inclusi;
        this.inSconto = pacchetto.inSconto === '1' ? true : false;
        this.isBestsellers = pacchetto.isBestsellers === '1' ? true : false;
        this.nome = pacchetto.nome;
        this.opzioni = pacchetto.opzioni;
        this.ordine = parseInt(pacchetto.ordine, 10);
        this.pubblica = pacchetto.pubblica === '1' ? true : false;
        this.titolo = pacchetto.titolo;
        this.vini = pacchetto.vini;
        this.qta = pacchetto.qta ? pacchetto.qta : 0;
        this.visite = pacchetto.visite;
        this.buono = parseInt(pacchetto.buono, 10);
        this.tags = pacchetto.tags ? pacchetto.tags : [];
        this.recensioni = pacchetto.recensioni;
        this.totVenduti = pacchetto.totVenduti;
        this.evidenza = pacchetto.evidenza === '1' ? true : false;
        this.idregione = pacchetto.idregione;
        this.giorniOffset = pacchetto.giorniOffset && pacchetto.giorniOffset !== '0' ? pacchetto.giorniOffset : '1/2';
        this.winecoins = parseInt(pacchetto.winecoins, 10);
        this.denominazione = pacchetto.denominazione;
        this.slider = pacchetto.slider ? pacchetto.slider : [];
        this.modrewrite = pacchetto.modrewrite;
        this.regione = pacchetto.regione;
        this.provincia = pacchetto.provincia;
    }

    getCosto() {
        let costo = 0;
        costo += this.choosePrezzoScontato();
        if (this.opzioni && this.opzioni.length > 0) {
            for (const opzione of this.opzioni) {
                if (opzione.selezionata) {
                    costo += parseFloat(opzione.costo);
                }
            }
        }
        return costo;
    }

    hasAssociata() {
        if (this.associate && this.associate_sconto != 0) {
            return true;
        } else {
            return false;
        }
    }

    hasSconto() {
        return this.inSconto;
    }

    public choosePrezzoScontato(pacchetto?): number {
        return this.inSconto ? this.costo_scontato : this.costo;
    }

    percentualeSconto() {
        const first = this.costo;
        const last = this.choosePrezzoScontato();
        return last * 100 / first - 100;
    }

    durataPromo() {
        const durata = moment(this.finePromo).diff(moment(), 'days');
        return durata != 0 ? durata : 1;
    }

}
